"use client";
import { Api } from "@/Apis";
import { LandingSelectGetCenterDepartmentsInputApiModel } from "@/Apis/ClinicApi";
import { Helper } from "@/Helpers";
import { selectProps } from "@/Helpers/Constants";
import { useDeepCompareEffectDebounce } from "@ant-design/pro-components";
import { Select, SelectProps } from "antd";
import { FC, useEffect, useState } from "react";

export interface LandingCenterDepartmentSelectProps
  extends SelectProps, LandingSelectGetCenterDepartmentsInputApiModel {
  autoSelectFirstOption?: boolean;
  autoSelectWhenThereIsOne?: boolean;
}

const LandingCenterDepartmentSelect: FC<LandingCenterDepartmentSelectProps> = ({
  autoSelectFirstOption,
  autoSelectWhenThereIsOne,
  CenterBranchId,
  CenterId,
  TypeKey,
  ServiceTypeKey,
  CommodityTypeKey,
  ...props
}) => {
  const model: LandingSelectGetCenterDepartmentsInputApiModel = {
    CenterBranchId,
    CenterId,
    TypeKey,
    ServiceTypeKey,
    CommodityTypeKey,
  };
  useDeepCompareEffectDebounce(
    () => {
      getOptions();
    },
    [model],
    [],
    1000,
  );

  const [options, setOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const getOptions = async () => {
    setLoading(true);
    const { Result } = await Api.LandingSelect.getCenterDepartments(model);
    const options = Helper.arrayToOptions(Result);
    setOptions(options);
    if (autoSelectFirstOption && options.length > 0)
      props.onChange?.(options[0].value, options[0]);
    setLoading(false);
  };
  useEffect(() => {
    if (autoSelectWhenThereIsOne && options.length == 1)
      props.onChange?.(options[0].value, options[0]);
  }, [JSON.stringify(options)]);
  return (
    <Select
      options={options}
      loading={loading}
      {...selectProps}
      {...(props as any)}
      value={
        options?.map((p) => p.value).includes(props.value)
          ? props.value
          : undefined
      }
    />
  );
};

export default LandingCenterDepartmentSelect;
